<template>
  <div class="selectln-container" :style="cssProps">
        <Multiselect
            aria-required="true"
			id="linea_ms"
            class="select-linea"
            label="name"
            track-by="code"
            placeholder="Seleccione"
            v-model="linea"
            :options="combolineas"
            :multiple="false"
            :allow-empty="false"
            @input="validateInput()"
			:max-height="340"
			selected-label="done"
			select-label="done"
			deselect-label=""
			:searchable="false"
			:disabled="disabledLinea"

        >
            <template v-slot:noOptions>No se encontraron resultados.</template>
            <template v-slot:noResult>No se encontraron resultados.</template>
			<template slot="option" slot-scope="props">
				<span class="option-icon" :style="'background-color:' + props.option.color">
					<i class="material-icons" :style="'color:' + props.option.icono_color">
						{{props.option.icono}}
					</i>
				</span>
				{{ props.option.name }}
			</template>
			<template slot="singleLabel" slot-scope="props">
				<span class="option-icon" :style="'background-color:' + props.option.color">
					<i class="material-icons" :style="'color:' + props.option.icono_color">
						{{props.option.icono}}
					</i>
				</span>
				{{ props.option.name }}
			</template>
        </Multiselect>
  </div>
</template>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style scoped>
.select-linea{color:var(--text-navbar-color);}
.select-linea >>> .multiselect__single{color:var(--text-navbar-color);}
.select-linea >>> .multiselect__tags{border-right: solid 1px var(--border-navbar-color);border-left: solid 1px var(--border-navbar-color);}
.select-linea >>> .multiselect__select:before{border-top-color:var(--border-navbar-color);}
</style>

<script>
import { mapState, mapActions } from 'vuex'
import Loading from 'vue-loading-overlay'
import Multiselect from 'vue-multiselect'

export default {
	name: 'LineaNegocio',
	components: {
		Loading,
		Multiselect
	},
	data () {
		return {
			combolineas: [],
			linea: null
		}
	},
	mounted () {
		this.setLineas()
	},
	computed: {
		...mapState(['accessLineas', 'lineaNegocio', 'bgNavbarColor', 'textNavbarColor', 'borderNavbarColor', 'logo', 'isotipo', 'disabledLinea']),
		cssProps () {
			return {
				'--bg-navbar-color': this.bgNavbarColor,
				'--text-navbar-color': this.textNavbarColor,
				'--border-navbar-color': this.borderNavbarColor
			}
		}
	},
	methods: {
		...mapActions(['logout', 'doLineaNegocio', 'setColorBarra', 'setBgNavbarColor', 'setTextNavbarColor', 'setBorderNavbarColor', 'setLogo', 'setIsotipo']),
		validateInput: function () {
			if (this.linea.code === '') {
				this.doLineaNegocio(null)
				this.setColorBarra('#1554f6')

				this.setBgNavbarColor('#1554f6')
				this.setTextNavbarColor('#FFF')
				this.setBorderNavbarColor('rgba(255,255,255,.1)')
				this.setLogo('')
				this.setIsotipo('')
			} else {
				this.doLineaNegocio(this.linea)
				this.setColorBarra(this.linea.color)

				this.setBgNavbarColor(this.linea.bg_navbar_color)
				this.setTextNavbarColor(this.linea.text_navbar_color)
				this.setBorderNavbarColor(this.linea.border_navbar_color)
				this.setLogo(this.linea.svg_logo)
				this.setIsotipo(this.linea.svg_isotipo)
			}
		},
		setLineas: function () {
			if (this.accessLineas.length) {
				this.accessLineas.forEach((value, key) => {
					this.combolineas.push({ code: parseInt(value.id_linea), name: value.nombre_linea, tipoLinea: parseInt(value.tipoLinea), nombreNegocio: value.nombre_tipo, txtDeudor: value.txtDeudor, txtCliente: value.txtCliente, txtContrato: value.txtContrato, color: value.color, icono: value.icono, icono_color: value.icono_color, bg_navbar_color: value.bg_navbar_color, text_navbar_color: value.text_navbar_color, border_navbar_color: value.border_navbar_color, svg_logo: value.svg_logo, svg_isotipo: value.svg_isotipo, hoja_ruta: value.hoja_ruta, id_pais: value.id_pais })
				})
				if (this.lineaNegocio !== null) {
					this.linea = this.lineaNegocio
				} else {
					this.linea = this.combolineas[0]
					this.doLineaNegocio(this.linea)
					this.setColorBarra(this.linea.color)

					this.setBgNavbarColor(this.linea.bg_navbar_color)
					this.setTextNavbarColor(this.linea.text_navbar_color)
					this.setBorderNavbarColor(this.linea.border_navbar_color)
					this.setLogo(this.linea.svg_logo)
					this.setIsotipo(this.linea.svg_isotipo)
				}
			}
		}
	},
	watch: {
		lineaNegocio: function (val) {
			if (this.lineaNegocio !== null) {
				this.tipoLinea = parseInt(this.lineaNegocio.tipoLinea)
				this.ocultarMenuBolsa(this.tipoLinea)
			}
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/components/ui/LineaNegocio.vue